// Utility functions for exporting data as CSV and PDF

// Export data as CSV
export const exportToCSV = (data, filename = 'export.csv') => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  // Define headers based on the data structure
  const headers = ['#', 'Student Name', 'Course', 'Asana', 'Date', 'Performance (%)'];

  // Convert data to CSV format
  const csvContent = [
    headers.join(','),
    ...data.map((item, index) =>
      [
        index + 1,
        `"${item.studentName || ''}"`,
        `"${item.courseName || ''}"`,
        `"${item.asanaName || ''}"`,
        `"${new Date(item.date).toISOString().split('T')[0] || ''}"`,
        item.performance || ''
      ].join(',')
    )
  ].join('\n');

  // Create and download the file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Export data as PDF using jsPDF
export const exportToPDF = async (data, filename = 'export.pdf') => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  try {
    // Dynamically import jsPDF to avoid bundle size issues
    const { default: jsPDF } = await import('jspdf');
    const { default: autoTable } = await import('jspdf-autotable');

    const doc = new jsPDF();

    // Add title
    doc.setFontSize(16);
    doc.text('Student Reports', 14, 22);
    doc.setFontSize(10);

    // Prepare table data
    const tableData = data.map((item, index) => [
      index + 1,
      item.studentName || '',
      item.courseName || '',
      item.asanaName || '',
      new Date(item.date).toISOString().split('T')[0] || '',
      item.performance || ''
    ]);

    // Add table
    autoTable(doc, {
      head: [['#', 'Student Name', 'Course', 'Asana', 'Date', 'Performance (%)']],
      body: tableData,
      startY: 30,
      styles: {
        fontSize: 8,
        cellPadding: 2
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: 255
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });

    // Save the PDF
    doc.save(filename);
  } catch (error) {
    console.error('Error generating PDF:', error);
    // Fallback to CSV if PDF generation fails
    exportToCSV(data, filename.replace('.pdf', '.csv'));
  }
};

// Generate filename with timestamp
export const generateFilename = (prefix = 'student-reports', format = 'csv') => {
  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
  return `${prefix}-${timestamp}.${format}`;
};
